<template>
  <v-toolbar flat color="white" density="compact">
    <v-toolbar-title class="text-primary">{{ label }}</v-toolbar-title>
    <v-spacer/>
    <base-action-button v-if="create" @action="linkAsset">
      <template #prepend><PhLink style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
      {{ $store.getters.translate("link") }}
    </base-action-button>
  </v-toolbar>
  <v-list v-if="assets && assets.length > 0" density="compact">
    <v-list-item v-for="(asset, index) in assets" :key="index" color="primary">
      <v-list-item-title>
        <a class="sm-bold" @click="$router.push('/resources?id=' + asset.id)">{{ asset.name }}</a>
      </v-list-item-title>
      <v-list-item-subtitle>
        <span class="tiny-normal">{{ moment(asset.created_at).format("DD-MM-YYYY HH:mm") }}</span>
      </v-list-item-subtitle>
      <template v-if="deletable" #append>
        <v-list-item-action>
          <v-menu>
            <template #activator="{ props }">
              <v-btn elevation="0" icon v-bind="props">
                <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="unlinkAsset(asset.id)">
                <template #prepend><PhLinkBreak size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('unlink') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item-action>
      </template>
    </v-list-item>
  </v-list>
  <div class="reg-normal text-primary mt-3 ml-5" v-else>{{ $store.getters.translate("nothing_found") }}</div>
  <base-link-asset modal_name="link_asset" ref="link_asset" @refresh="addAssetIds" :page="page"/>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseActionButton from "./BaseActionButton";
import BaseLinkAsset from "./BaseLinkAsset";
import {PhDotsThreeVertical, PhLink, PhLinkBreak} from "@phosphor-icons/vue";

export default {
  components: {BaseLinkAsset, BaseActionButton, PhLinkBreak, PhLink, PhDotsThreeVertical},
  props: ["page", "parent_id", "label", "assets", "asset_ids", "deletable", "create", "link_immediately"],
  methods: {
    async addAssetIds(ids) {
      if(this.link_immediately) {
        await helpFunctions.postCustomRoute(this.$toast, this.page.name + "/linkassets", {id: this.parent_id, asset_ids: ids}, true, true);
        this.$emit('refresh');
      }
      else {
        this.$emit('assetsAdded', ids);
      }
    },
    linkAsset() {
      this.$refs.link_asset.load();
      this.$refs.link_asset.selected_assets = this.asset_ids;
    },
    async unlinkAsset(asset_id) {
      if(this.link_immediately) {
        this.$confirm(this.$store.getters.translate("are_you_sure")).then(async (res) => {
          if (res) {
            await helpFunctions.postCustomRoute(this.$toast, this.page.name + "/unlinkasset", {id: this.parent_id, asset_id: asset_id}, true, true);
            this.$emit('refresh');
          }
        });
      }
    },
  },
};
</script>